// @ts-ignore
export const stop = async ({ commit }) => {
  commit('stop');
};

// @ts-ignore
export const warning = async ({ commit }, message) => {
  commit('start', { message, color: 'warning' });
};

// @ts-ignore
export const danger = async ({ commit }, message) => {
  commit('start', { message, color: 'error' });
};

// @ts-ignore
export const error = async ({ commit }, message) => {
  // TODO: parse JOI error message
  const fields = [];
  if (message.response && message.response.data && message.response.data.errors) {
    for (const field of message.response.data.errors) {
      fields.push(field.messages[0]);
    }
    commit('start', { message: fields.join('<br/>'), color: 'error' });
  } else if (message.message) {
    commit('start', { message: message.message, color: 'error' });
  } else {
    commit('start', { message, color: 'error' });
  }
};

// @ts-ignore
export const notify = async ({ commit }, message) => {
  commit('start', { message, color: 'orange darken-1' });
};

// @ts-ignore
export const info = async ({ commit }, message) => {
  commit('start', { message, color: 'info' });
};

// @ts-ignore
export const success = async ({ commit }, message) => {
  commit('start', { message, color: 'success' });
};
